import { ScoreComponent } from './score.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '../../components/components.module';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


@NgModule({
    declarations:[
        ScoreComponent

    ],
    imports:[
        ComponentsModule,
        AngularFontAwesomeModule,
        BrowserModule,
        FormsModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports:[
        ScoreComponent
    ]
})
export class ScoreModule {}

 // required for AOT compilation
 export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }